/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "~/backend/axiosClient"
import type {
  FindProductsTraceabilityQueryResponse,
  FindProductsTraceabilityQueryParams,
} from "../types/FindProductsTraceability.ts"
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query"
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"
import { queryOptions, useQuery } from "@tanstack/react-query"

export const findProductsTraceabilityQueryKey = (
  params: FindProductsTraceabilityQueryParams
) =>
  [
    { url: "/v1/product/find-products-traceability" },
    ...(params ? [params] : []),
  ] as const

export type FindProductsTraceabilityQueryKey = ReturnType<
  typeof findProductsTraceabilityQueryKey
>

/**
 * @summary Find products traceability
 * {@link /v1/product/find-products-traceability}
 */
export async function findProductsTraceability(
  params: FindProductsTraceabilityQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    FindProductsTraceabilityQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: "GET",
    url: `/v1/product/find-products-traceability`,
    params,
    ...requestConfig,
  })
  return res
}

export function findProductsTraceabilityQueryOptions(
  params: FindProductsTraceabilityQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const queryKey = findProductsTraceabilityQueryKey(params)
  return queryOptions<
    ResponseConfig<FindProductsTraceabilityQueryResponse>,
    ResponseErrorConfig<Error>,
    ResponseConfig<FindProductsTraceabilityQueryResponse>,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return findProductsTraceability(params, {
        ...config,
        signal: config.signal ?? signal,
      })
    },
  })
}

/**
 * @summary Find products traceability
 * {@link /v1/product/find-products-traceability}
 */
export function useFindProductsTraceability<
  TData = ResponseConfig<FindProductsTraceabilityQueryResponse>,
  TQueryData = ResponseConfig<FindProductsTraceabilityQueryResponse>,
  TQueryKey extends QueryKey = FindProductsTraceabilityQueryKey,
>(
  params: FindProductsTraceabilityQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        ResponseConfig<FindProductsTraceabilityQueryResponse>,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: Client }
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const queryKey =
    resolvedOptions?.queryKey ?? findProductsTraceabilityQueryKey(params)

  const query = useQuery(
    {
      ...findProductsTraceabilityQueryOptions(params, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey
  }

  query.queryKey = queryKey as TQueryKey

  return query
}
